import AccessLog from './accessLog';
import connectionGroup from './connectionGroup';
import connections from './connections';
import delegatedTasks from './delegatedTasks';
import delegationConfigurations from './delegationConfigurations';
import delegations from './delegations';
import DynamicEntity from './dynamicEntity';
import emailMessageTrace from './emailMessageTrace';
import teamsMessageTrace from './teamsMessageTrace';
import smsMessageTrace from './smsMessageTrace';
import emailTemplate from './emailTemplate';
import emailNotificationTemplate from './emailTemplate';
import Environment from './environment';
import FormInstanceData from './formInstanceData';
import InstanceActionType from './instanceActionType';
import ManageAgents from './manageAgents';
import ManageEntities from './manageEntities';
import ManageLists from './manageLists';
import ManageListTaskTrace from './manageListTaskTrace';
import ManageProcess from './manageProcess';
import ManageProcessPortalConfig from './manageProcessPortalConfig';
import ManageReports from './manageReports';
import ReportGroup from './reportGroup';
import ReportToken from './reportToken';
import ManageSequenceTraces from './manageSequenceTraces';
import ManageSubSequence from './manageSubSequence';
import ManageTokenTrace from './manageTokenTrace';
import NameAndDescription from './nameAndDescription';
import NameDescriptionIsActive from './nameDescriptionIsActive';
import PowerBIServerConfiguration from './powerBIServerConfiguration';
import ProcessGroup from './processGroup';
import ProcessInstanceDetails from './processInstanceDetails';
import Requests from './requests';
import Tasks from './tasks';
import Trace from './trace';
import aiConsumption from './aiConsumption';
import AiBillingBudgetPeriod from './aiBillingBudgetPeriod';
import AiBillingCredit from './aiBillingCredit';
import BillingSubscription from './billingSubscription';
import ChannelDistributor from './channelDistributor';
import ChannelPartner from './channelPartner';
import ChannelReseller from './channelReseller';
import userGroup from './userGroup';
import UserPosition from './userPosition';
import UserExtraField from './userExtraField';
import UserDevice from './userDevice';
import ShortenedUrl from './shortenedUrl';
import Sequence from './sequence';
import Media from './media';
import MediaCategory from './mediaCategory';
import AiSkill from './aiSkill';

/** Namespace to serve DB Queries */
const CoreQueries = (() => {
  return {
    Requests,
    ProcessInstanceDetails,
    FormInstanceData,
    ManageReports,
    ReportGroup,
    ReportToken,
    ManageProcess,
    ManageAgents,
    ManageLists,
    ManageListTaskTrace,
    UserPosition,
    UserExtraField,
    UserDevice,
    ManageEntities,
    NameAndDescription,
    AccessLog,
    NameDescriptionIsActive,
    Trace,
    aiConsumption,
    AiBillingBudgetPeriod,
    AiBillingCredit,
    BillingSubscription,
    ChannelDistributor,
    ChannelPartner,
    ChannelReseller,
    ProcessGroup,
    PowerBIServerConfiguration,
    Tasks,
    ManageSubSequence,
    ManageSequenceTraces,
    ManageTokenTrace,
    InstanceActionType,
    ManageProcessPortalConfig,
    userGroup,
    connections,
    emailMessageTrace,
    teamsMessageTrace,
    smsMessageTrace,
    emailTemplate,
    emailNotificationTemplate,
    connectionGroup,
    delegations,
    delegationConfigurations,
    delegatedTasks,
    DynamicEntity,
    Environment,
    ShortenedUrl,
    Sequence,
    Media,
    MediaCategory,
    AiSkill,
  };
})();

export default CoreQueries;
